import React, { Component } from "react";

export default class CategoryCreate extends Component {

  constructor(props) {
    super(props);
    this.state = {name: '', code: ''};


    // Fast redirection?
    if(!this.state.user || this.state.user.role != 'admin')
      window.location.replace('/login');
    // Bindings
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {}

  onChange = (e) => {
    const state = this.state
    state[e.target.name] = e.target.value;
    this.setState(state);
  }

  onSubmit(event) {
    event.preventDefault();
    const formData = this.state;
    console.log(formData);
    fetch(process.env.REACT_APP_API_URL + '/categories/create', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then((response) => {
      return response.json();
    })
    .then((data) => {
      console.log('data', data);
      this.props.history.push('/categories');
    })
  }

  render() {
    return (
      <form id="new-form" className="form container" method="POST" onSubmit={ this.onSubmit }>
        <div className="form-group">
          <label>Name</label>
          <input name="name" className="form-control form-control-lg" onChange={ this.onChange } />
        </div>
        <div className="form-group">
          <label>Code</label>
          <input name="code" className="form-control form-control-lg" onChange={ this.onChange } />
        </div>
        <input type="submit" className="btn btn-primary" value="Submit" />
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/CategoryCreate.jsx